<template>
  <div class="content" v-if="loadOrganisation">
    <base-header class="pb-6">
    </base-header>
    <b-container fluid class="mt--6">
      <card class="bg-transparent" >
        <template slot="header">
          <div style="display: flex;">
            <div>
              <h3 class="mb-0">Synchronization</h3>
              <p class="text-sm mb-0">
                Synchronize entities with remote servers
              </p>
            </div>
            <div style="flex: 1.5;">
              <base-button size="sm" type="neutral" v-if="syncConfiguration && !editSettings" @click.native="handleSync()" style="float: right;">Sync now</base-button>
              <base-button size="sm" type="neutral" v-if="syncConfiguration && !editSettings" @click.native="handleUpdateExternalIDs()" style="float: right;">Update external IDs</base-button>
            </div>
          </div>
        </template>
        <div>
          <b-row v-if="!editSettings">
            <b-col cols="12">
              <b-card no-body v-if="loadSyncConfiguration">
                <b-card-header>
                  <h5 class="h3 mb-0">Settings</h5>
                  <div style="flex: 1.5;">
                    <base-button size="sm" type="neutral" v-if="!editSettings" @click.native="handleEditSettings()" style="float: right;">Edit</base-button>
                  </div>
                </b-card-header>
                <b-card-body v-if="hasSyncConfiguration">
                  <div v-if="syncConfiguration.active">
                    Sync is <b>active</b>
                  </div>
                  <div v-else>
                    Sync is <b>inactive</b>
                  </div>
                  <p/>
                  <b-row>
                    <b-col cols="3">
                      <div>
                        Remote organisation : <b>{{ syncConfiguration.remoteOrganisation }}</b>
                      </div>
                      <div>
                        Remote server : <b>{{ syncConfiguration.server }}</b>
                      </div>
                      <div>
                        Sync inactive : <b>{{ syncConfiguration.syncInactive }}</b>
                      </div>
                      <div>
                        Sync every : <b>{{ $formatDuration(syncConfiguration.rate) }}</b>
                      </div>
                      <div>
                        Last sync time : <b>{{ $formatDateTime(new Date(syncConfiguration.lastSync)) }}</b>
                      </div>
                      <div v-if="syncConfiguration.active">
                        Next sync time : <b>{{ getNextSyncTime() }}</b>
                      </div>
                    </b-col>
                    <b-col cols="3">
                      <div>Devices : <b>{{ syncConfiguration.syncDevices }}</b></div>
                      <div>Assets : <b>{{ syncConfiguration.syncAssets }}</b></div>
                      <div>Drivers : <b>{{ syncConfiguration.syncDrivers }}</b></div>
                      <div>Groups : <b>{{ syncConfiguration.syncGroups }}</b></div>
                      <div>Configuration groups : <b>{{ syncConfiguration.syncConfigurationGroups }}</b></div>
                    </b-col>
                  </b-row>
                </b-card-body>
                <b-card-body v-else >
                  No synchronization settings available
                </b-card-body>
              </b-card>
            </b-col>
          </b-row>
          <b-row v-if="editSettings">
            <b-col cols="12">
              <b-card no-body>
                <b-card-header>
                  <h5 class="h3 mb-0">Edit settings</h5>
                </b-card-header>
                <b-card-body>
                  <form>
                    <b-container fluid="xl">
                      <b-row>
                        <b-col cols="3">
                          <div>
                            <base-input label="Remote organisation" v-model="syncConfiguration.remoteOrganisation" :required=true />
                          </div>
                          <div>
                            <base-input label="Remote server">
                              <el-select width="120"
                                         filterable
                                         placeholder="Servers"
                                         v-model="syncConfiguration.server"
                                         :required=true>
                                <el-option key="EasyTrack" label="EasyTrack" value="EasyTrack" />
                              </el-select>
                            </base-input>
                          </div>
                          <div>
                            <base-input type="number" label="Sync rate (s)" v-model.number="syncConfiguration.rate" :required=true />
                          </div>
                          <div>
                            <base-input label="Sync inactive entities">
                              <b-form-checkbox class="mb-3" v-model="syncConfiguration.syncInactive" />
                            </base-input>
                          </div>
                          <div>
                            <base-input label="Active">
                              <b-form-checkbox class="mb-3" v-model="syncConfiguration.active" />
                            </base-input>
                          </div>
                        </b-col>
                        <b-col cols="1">
                        </b-col>
                        <b-col cols="3">
                          <div>
                            <base-input label="Devices">
                              <b-form-checkbox class="mb-3" v-model="syncConfiguration.syncDevices" />
                            </base-input>
                          </div>
                          <div>
                            <base-input label="Assets">
                              <b-form-checkbox class="mb-3" v-model="syncConfiguration.syncAssets" />
                            </base-input>
                          </div>
                          <div>
                            <base-input label="Drivers">
                              <b-form-checkbox class="mb-3" v-model="syncConfiguration.syncDrivers" />
                            </base-input>
                          </div>
                          <div>
                            <base-input label="Groups">
                              <b-form-checkbox class="mb-3" v-model="syncConfiguration.syncGroups" />
                            </base-input>
                          </div>
                          <div>
                            <base-input label="Configuration groups">
                              <b-form-checkbox class="mb-3" v-model="syncConfiguration.syncConfigurationGroups" />
                            </base-input>
                          </div>
                        </b-col>
                      </b-row>
                      <b-row>
                        <b-col cols="1">
                          <div>
                            <base-button size="sm" type="neutral" @click.native="handleSaveSettings">Save</base-button>
                            <base-button size="sm" type="neutral" @click.native="handleCancelSettings">Cancel</base-button>
                          </div>
                        </b-col>
                      </b-row>
                    </b-container>
                  </form>
                </b-card-body>
              </b-card>
            </b-col>
          </b-row>
          <b-row v-if="!editSettings">
            <b-col cols="12">
              <b-card no-body v-if="loadSyncResults">
                <b-card-header>
                  <h5 class="h3 mb-0">Results</h5>
                  <div style="flex: 1.5;">
                    <base-button size="sm" type="neutral" v-if="!editSettings" @click.native="handleRefresh()" style="float: right;">Refresh</base-button>
                  </div>
                </b-card-header>
                <b-card-body>
                  <sync-result-card v-for="(item, index) in syncResults" :syncResult="item"></sync-result-card>
                </b-card-body>
              </b-card>
            </b-col>
          </b-row>
        </div>
      </card>
    </b-container>
  </div>
</template>

<script>
import crudApi from "../../crud/crud-api";
import moment from "moment";
import SyncResultCard from "./SyncResultCard";
import {Option, Select} from "element-ui";
import {formatDateTime} from "../../util/formatting";

export default {
  name: "Synchronization",
  components: {
    SyncResultCard,
    [Select.name]: Select,
    [Option.name]: Option,
  },
  data: _ => ({
    organisation: {},
    syncConfiguration: null,
    syncResults: null,
    remoteOrganisations: null,
    editSettings: false,
    from: moment().format().slice(0,10)
  }),
  methods: {
    handleSync() {
      crudApi.syncOrganisation(this.$store.state.auth.user.organisation_id)
    },
    handleUpdateExternalIDs() {
      crudApi.updateOrganisationExternalIDs(this.$store.state.auth.user.organisation_id)
    },
    handleEditSettings() {
      if (!this.syncConfiguration) {
        this.syncConfiguration = {
          "organisationId": this.$store.state.auth.user.organisation_id,
          "active": true,
          "server": "EasyTrack",
          "rate": 7200,
          "syncDevices": true,
          "syncAssets": true,
          "syncDrivers": true,
          "syncGroups": true,
          "syncConfigurationGroups": true,
          "syncInactive": false,
          "lastSync": null,
          "remoteOrganisation": null
        }
      }

      this.editSettings = true
    },
    handleSaveSettings() {
      if (!this.syncConfiguration.id) {
        crudApi.createSyncConfiguration(this.$store.state.auth.user.organisation_id, this.syncConfiguration).then(json => this.syncConfiguration.id = json.data ? json.data._id : json._id)
      } else {
        crudApi.updateSyncConfiguration(this.syncConfiguration)
      }

      this.editSettings = false
    },
    handleCancelSettings() {
      this.getSyncConfiguration()

      new Promise(resolve => setTimeout(resolve, 100)).then(() => this.editSettings = false);
    },
    handleRefresh() {
      this.getSyncConfiguration()

      this.getSyncResults()
    },
    getOrganisation() {
      crudApi.getOrganisation(this.$store.state.auth.user.organisation_id).then(json => this.organisation = json.data ? json.data : json)
    },
    getSyncConfiguration() {
      crudApi.getSyncConfiguration(this.$store.state.auth.user.organisation_id).then(json => this.syncConfiguration = json.data ? json.data : json)
    },
    getSyncResults() {
      let from = new Date()
      if (this.from) {
        from = new Date(this.from+'T'+'00:00:00')
      }

      let until = undefined
      if (this.from) {
        until = new Date(this.from+'T'+'23:59:59')
      }

      crudApi.getSyncResults(this.$store.state.auth.user.organisation_id, from, until).then(json => this.syncResults = json.data ? json.data : json)
    },
    getNextSyncTime() {
      if (!this.syncConfiguration) {
        return ""
      }

      if (new Date(this.syncConfiguration.lastSync).getTime() + (this.syncConfiguration.rate*1000) < new Date().getTime()) {
        return formatDateTime(new Date())
      } else {
        return formatDateTime(new Date(new Date(this.syncConfiguration.lastSync).getTime() + (this.syncConfiguration.rate*1000)))
      }
    }
  },
  computed: {
    loadOrganisation() {
      this.getOrganisation()

      return true
    },
    loadSyncConfiguration() {
      this.getSyncConfiguration()

      return true
    },
    hasSyncConfiguration() {
      return this.syncConfiguration != null
    },
    loadSyncResults() {
      this.getSyncResults()

      return true
    },
  }
}
</script>

<style scoped>

</style>
